import { captureException } from '@core/plugins/sentry';

export const copyToClipboard = async (text: string) => {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard?.writeText(text);
    } catch (err) {
      captureException(err);
    }
  }
};
